import React, { useState } from 'react';
import { Button } from '@attentive-platform/stem-ui';

import { fetchApiData } from '../Utils/ApiCalls';

import { USER_MFA_DISABLE_ENDPOINT } from '../urls';

import useFormStatus from '../Hooks/useFormStatus';

import { Alert } from './Alert';

const UserMFADisable = () => {
	const [email, setEmail] = useState('');

	const { successMessage, errorMessage, handleApiResult } = useFormStatus();

	const handleSubmit = async e => {
		e.preventDefault();

		// Create an object with the form data
		const formData = {
			email: email.toLowerCase()
		};
		// Make the POST request to the API with the form data
		const response = await fetchApiData({
			endpoint: USER_MFA_DISABLE_ENDPOINT,
			data: formData
		});

		handleApiResult(response);
		setEmail('');
	};

	return (
		<>
			<form onSubmit={handleSubmit} className='w-100'>
				<Alert errorMessage={errorMessage} successMessage={successMessage} />

				<div className='input-group mb-3'>
					<input
						type='Email'
						value={email}
						onChange={e => setEmail(e.target.value)}
						required
						className='form-control form-control-lg'
						placeholder='Email'
						aria-label='Email'
					/>
				</div>

				<div className='button'>
					<Button color='primary' size='large' variant='contained' type='submit'>
						Disable MFA
					</Button>
				</div>
			</form>
		</>
	);
};

export default UserMFADisable;
